window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1000 / 60);
  };

function waitUntil(conditionFn) {
  return new Promise((resolve) => {
    function checkCondition() {
      if (conditionFn()) {
        resolve();
      } else {
        requestAnimationFrame(checkCondition);
      }
    }
    checkCondition();
  });
}


window["CP_SP_Cart_01_V1"] = function () {
  if (
    document.querySelector("body") &&
    document.querySelector("#CartDrawer") &&
    !document.body.classList.contains("CP_SP_Cart_01_V1")
  ) {
    document.body.classList.add("CP_SP_Cart_01_V1");

    (function (win) {
      "use strict";
      const listeners = [];
      const doc = win.document;
      const MutationObserver =
        win.MutationObserver || win.WebKitMutationObserver;
      const processed = new WeakSet(); // Use WeakSet to track handled elements
      let observer;

      function ready(selector, fn) {
        listeners.push({ selector, fn });

        if (!observer) {
          observer = new MutationObserver(check);
          observer.observe(doc.documentElement, {
            childList: true,
            subtree: true,
          });
        }

        check(); // Initial check
      }

      function check() {
        for (let i = 0; i < listeners.length; i++) {
          const { selector, fn } = listeners[i];
          const elements = doc.querySelectorAll(selector);

          elements.forEach((element) => {
            if (!processed.has(element)) {
              processed.add(element);
              fn.call(element, element);
            }
          });
        }
      }

      win.eleReady = ready;
    })(this);

      function updateCartDrawer() {
      fetch("/?sections=cart-drawer")
        .then((res) => res.json())
        .then((data) => {
          const parser = new DOMParser();
          const newHTML = parser.parseFromString(
            data["cart-drawer"],
            "text/html"
          );
          const newDrawer = newHTML.querySelector("cart-drawer");
          const currentDrawer = document.querySelector("cart-drawer");

          if (currentDrawer && newDrawer) {
            currentDrawer.innerHTML = newDrawer.innerHTML;

            document.body.classList.add("js-drawer-open");
          }
        })
        .catch((err) => {
          console.error("Error updating cart drawer:", err);
        });
    }

    function addToCart(variantId) {
      const formData = {
        id: variantId,
        quantity: 1,
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((res) => res.json())
        .then(() => {
          updateCartDrawer();
        })
        .catch((err) => {
          console.error("Error adding to cart:", err);
        });
    }

    const ratings = [ 
                      `
                      <div class="CP-review-card">
                        <div class="CP-user-image">YK</div>
                        <div class="CP-user-review">
                          <div class="CP-review-user-row">
                            <span class="CP-review-user">Yuvaraj K.</span>
                            <span class="CP-review-stars">★★★★★</span>
                          </div>
                          <div class="CP-review-title">Awesome</div>
                          <div class="CP-review-content">Excellent responce while breaking and awesome product worth for this price.</div>
                        </div>
                      </div>
                      `, 
                      `
                      <div class="CP-review-card">
                        <div class="CP-user-image">HP</div>
                        <div class="CP-user-review">
                          <div class="CP-review-user-row">
                            <span class="CP-review-user">Hrishi P.</span>
                            <span class="CP-review-stars">★★★★★</span>
                          </div>
                          <div class="CP-review-title">Quick delivery and perfect product</div>
                          <div class="CP-review-content">The air filter was a perfect fit for my Dec-2023 hness. This air filter with Iridium spark plugs and Silver stallion exhaust made my bike louder and gave better performance.</div>
                        </div>
                      </div>
                      `, 
                      `
                      <div class="CP-review-card">
                        <div class="CP-user-image">SD</div>
                        <div class="CP-user-review">
                          <div class="CP-review-user-row">
                            <span class="CP-review-user">Sabyasachi D.</span>
                            <span class="CP-review-stars">★★★★★</span>
                          </div>
                          <div class="CP-review-title">Wonderful Product</div>
                          <div class="CP-review-content">Perfect fit and wonderful product and good rate.</div>
                        </div>
                      </div>
                      `, 
                      `
                      <div class="CP-review-card">
                        <div class="CP-user-image">A</div>
                        <div class="CP-user-review">
                          <div class="CP-review-user-row">
                            <span class="CP-review-user">Amit</span>
                            <span class="CP-review-stars">★★★★★</span>
                          </div>
                          <div class="CP-review-title">Superb product</div>
                          <div class="CP-review-content">Have been using the product for a few months now. The quality is good, buttons need some time to get used to. Sound is clear and mic quality is good too, intercom works great and is now a must have for all my rides. Would definitely recommend.</div>
                        </div>
                      </div>
                      `, 
                    ];


    const featureBox = `
                        <div class="CP-feature-container">
                            <div class="CP-feature-box">
                                <img src="https://cdn.shopify.com/s/files/1/0616/7799/4041/files/high-quality.png?v=1753777606" alt="High Quality" />
                                <p class="CP-feature-title">High <br />Quality</p>
                            </div>
                            <div class="CP-feature-box">
                                <img src="https://cdn.shopify.com/s/files/1/0616/7799/4041/files/credit-card.png?v=1753777607" alt="Secure Payments" />
                                <p class="CP-feature-title">Secure <br />Payments</p>
                            </div>
                            <div class="CP-feature-box">
                                <img src="https://cdn.shopify.com/s/files/1/0616/7799/4041/files/online-chat.png?v=1753777606" alt="Support" />
                                <p class="CP-feature-title">Top Notch <br />Support</p>
                            </div>
                        </div>
                        <div class="cp_cart_return">
                            <a href="https://returns.logisy.tech/returns?encipherencode=gAAAAABoIb82xnCtNXeiaE0-W382TtcFXqnYQB5xyUBAh521wcMFvPIwqJCMq2Y-vD49wNmoS7uKseLN8gwVXhsPJvHsi3sexg==">
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m482-200 114-113-114-113-42 42 43 43q-28 1-54.5-9T381-381q-20-20-30.5-46T340-479q0-17 4.5-34t12.5-33l-44-44q-17 25-25 53t-8 57q0 38 15 75t44 66q29 29 65 43.5t74 15.5l-38 38 42 42Zm165-170q17-25 25-53t8-57q0-38-14.5-75.5T622-622q-29-29-65.5-43T482-679l38-39-42-42-114 113 114 113 42-42-44-44q27 0 55 10.5t48 30.5q20 20 30.5 46t10.5 52q0 17-4.5 34T603-414l44 44ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"></path></svg>
                                Easy Return and Replacement
                            </a>
                        </div>
                      `;
    eleReady("#CartDrawer-CartItems .cart-item", function (cartItem) {
      const cartDrawer = cartItem.closest("cart-drawer-items");
      if (!cartDrawer) return;

      insertRatingsSection(cartDrawer);
      insertFeatureBox(cartDrawer);
      replaceRemoveIcons(cartDrawer);
      renderAlsoBoughtSection(cartDrawer);
      insertTrustBadge();
      insertLowStockMessage(cartItem);
    });

    function insertLowStockMessage(cartItem) {
      if (cartItem.querySelector(".CP-low-stock-message")) return;

      const productTable = cartItem.querySelector("table");

      if (!productTable) return;

      const link = cartItem.querySelector("a.cart-item__link");

      if (!link) return;

      const href = link.getAttribute("href");
      const variantIdMatch = href.match(/variant=(\d+)/);

      if (!variantIdMatch) return;

      const variantId = variantIdMatch[1];
      const inventory = window.cartVariantInventory?.[variantId];

      if (typeof inventory !== "number") return;
      if (inventory > 3) return;

      const messageText =
        inventory === 0
          ? "Selling fast - grab yours now!"
          : `😎 Only ${inventory} left in stock – grab yours now!`;

      const message = `
    <div class="CP-low-stock-message">
      ${messageText}
    </div>
  `;

      productTable.insertAdjacentHTML("afterend", message);
    }

    function insertTrustBadge() {
      if (document.querySelector(".CP-trust-badge")) return;

      const checkoutButton = document.querySelector(".gokwik-checkout");
      if (!checkoutButton) return;

      const badge = `<p class="CP-trust-badge">Trusted by 60,000+ Bikers</p>`;
      checkoutButton.insertAdjacentHTML("afterend", badge);
    }

    function insertRatingsSection(cartDrawer) {
      if (document.querySelector(".CP-ratings-container")) return;

      const ratingsWrapper = document.createElement("div");
      ratingsWrapper.classList.add("CP-ratings-wrapper");
      ratingsWrapper.innerHTML = ratings[0];

      const ratingsContainer = document.createElement("div");
      ratingsContainer.classList.add("CP-ratings-container");

      const swiperDots = document.createElement("div");
      swiperDots.classList.add("CP-swiper-dots");

      ratingsContainer.appendChild(ratingsWrapper);
      ratingsContainer.appendChild(swiperDots);

      let currentIndex = 0;

      function showRatingAt(index) {
        ratingsWrapper.innerHTML = ratings[index];
        updateDots(index);
      }

      function createDots() {
        swiperDots.innerHTML = "";
        ratings.forEach((_, index) => {
          const dot = document.createElement("span");
          dot.classList.add("CP-dot");
          if (index === currentIndex) dot.classList.add("active");
          dot.addEventListener("click", (e) => {
            e.stopPropagation();
            currentIndex = index;
            showRatingAt(index);
          });
          swiperDots.appendChild(dot);
        });
      }

      function updateDots(activeIndex) {
        swiperDots.querySelectorAll(".CP-dot").forEach((dot, i) => {
          dot.classList.toggle("active", i === activeIndex);
        });
      }

      let touchStartX = 0,
        touchEndX = 0;
      ratingsWrapper.addEventListener("touchstart", (e) => {
        touchStartX = e.touches[0].clientX;
      });
      ratingsWrapper.addEventListener("touchend", (e) => {
        touchEndX = e.changedTouches[0].clientX;
        handleSwipe(touchEndX - touchStartX);
      });

      let mouseDownX = 0,
        mouseUpX = 0,
        isMouseDown = false;
      ratingsWrapper.addEventListener("mousedown", (e) => {
        isMouseDown = true;
        mouseDownX = e.clientX;
      });
      ratingsWrapper.addEventListener("mouseup", (e) => {
        if (!isMouseDown) return;
        mouseUpX = e.clientX;
        isMouseDown = false;
        handleSwipe(mouseUpX - mouseDownX);
      });

      function handleSwipe(distance) {
        const threshold = 50;
        if (distance > threshold) {
          currentIndex = (currentIndex - 1 + ratings.length) % ratings.length;
        } else if (distance < -threshold) {
          currentIndex = (currentIndex + 1) % ratings.length;
        }
        showRatingAt(currentIndex);
      }

      createDots();
      showRatingAt(currentIndex);
      cartDrawer.insertAdjacentElement("beforebegin", ratingsContainer);
    }

    function insertFeatureBox(cartDrawer) {
      if (!document.querySelector(".CP-cart-return") && !document.querySelector(".CP-feature-container")){
      cartDrawer.insertAdjacentHTML("afterend", featureBox);
      }
    }

    function replaceRemoveIcons(cartDrawer) {
      const cards = cartDrawer.querySelectorAll(".cart-item");
      if (!cards || cards.length === 0) return;

      cards.forEach((card) => {
        const removeBtn = card.querySelector(".cart-remove-button");
        if (removeBtn && !removeBtn.querySelector("img")) {
          removeBtn.innerHTML = `
        <img class="CP-cart-remove" src="https://cdn.shopify.com/s/files/1/0616/7799/4041/files/delete.png?v=1753777606"/>
      `;
        }
      });
    }

    function renderAlsoBoughtSection(cartDrawer) {
      if (document.querySelector(".CP-also-bought-container")) return;

      const cards = cartDrawer.querySelectorAll(
        ".upsell_products_wrapper .upsell-product-card"
      );
      if (!cards || cards.length === 0) return;

      const section = document.createElement("div");
      section.className = "CP-card-container CP-also-bought-container";

      const heading = document.createElement("h2");
      heading.className = "CP-card-heading";
      heading.innerText = "You may also like";

      const scrollContainer = document.createElement("div");
      scrollContainer.className = "CP-scroll-container";

      cards.forEach((card) => {
        const title =
          card.querySelector(".upsell-product-title")?.innerText.trim() || "";
        const image =
          card.querySelector("img")?.getAttribute("src")?.trim() || "";
        const price =
          card.querySelector(".upsell-product-price")?.innerText.trim() || "";
        const oldPrice =
          card.querySelector(".upsell-product-old-price")?.innerText.trim() ||
          "";
        const dataId =
          card.querySelector(".upsell-add-button")?.getAttribute("data-id") ||
          "";

        const cardHTML = `
      <div class="CP-card" data-id="${dataId}">
        <img src="${image}" alt="${title}" class="CP-card-image" />
        <p class="CP-card-title">${title}</p>
        <div class="CP-card-bottom">
          <div class="CP-card-price">
          <div class="CP-card-current-price">${price}</div>
          ${oldPrice ? `<div class="CP-card-old-price">${oldPrice}</div>` : ""}
          </div>
          <img src="https://cdn.shopify.com/s/files/1/0496/1003/1256/files/cartIcon.png?v=1750331068" class="CP-cart-icon" alt="Cart Icon" data-id="${dataId}" />
        </div>
      </div>
    `;
        scrollContainer.insertAdjacentHTML("beforeend", cardHTML);
      });

      section.appendChild(heading);
      section.appendChild(scrollContainer);

      const featureContainer = document.querySelector(".cp_cart_return");
      if (featureContainer) {
        featureContainer.insertAdjacentElement("afterend", section);
      }

      section.querySelectorAll(".CP-cart-icon").forEach((icon) => {
        icon.addEventListener("click", (e) => {
          const variantId = e.currentTarget.getAttribute("data-id");
          if (variantId) {
            addToCart(variantId);
          }
        });
      });
    }
  } else if (!document.body.classList.contains("CP_SP_Cart_01_V1")) {
    window.requestAnimationFrame(window.CP_SP_Cart_01_V1);
  }
};

window.CP_SP_Cart_01_V1();
if(!location.pathname.includes('/search')) {
    window.requestAnimationFrame =
  window.requestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame ||
  function (timeOutFn) {
    return setTimeout(timeOutFn, 1000 / 60);
  };

let suggestBox;
let suggestHTML = '';

window["CP_SP_Search_Bar_04"] = function () {
  if (
    document.querySelectorAll(".search__input").length &&
    !document.body.classList.contains("CP_SP_Search_Bar_04")
  ) {
    document.body.classList.add("CP_SP_Search_Bar_04");
    
    const isDesktop = window.innerWidth > 786;
    const searchInput = document.querySelectorAll(".search__input")[isDesktop ? 0 : 2];
    const RECENT_KEY = "CP_SP_RECENT_SEARCHES";

    function getRecentSearches() {
      try {
        return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
      } catch {
        return [];
      }
    }

    function saveRecentSearch(term) {
      if (!term) return;
      let searches = getRecentSearches();
      term = term.trim();
      if (!term) return;
      searches = searches.filter((item) => item.toLowerCase() !== term.toLowerCase());
      searches.unshift(term);
      if (searches.length > 5) searches = searches.slice(0, 5);
      localStorage.setItem(RECENT_KEY, JSON.stringify(searches));
    }

    function renderRecentSearches() {
      const searches = getRecentSearches();
      if (!searches.length) return '';
      const items = searches
        .map((term) => `<a href="/search?q=${encodeURIComponent(term)}">${term}</a>`)
        .join('');
      return `
        <div class="defaultSuggestSections" data-title="Recent Searches">
          <div class="searchsuggesthead">Recent Searches</div>
          <div class="recentSearchBox">${items}</div>
        </div>
      `;
    }

    suggestHTML = `
      <div class="defaultSuggestSections" data-title="Popular Searches">
        <div class="searchsuggesthead">Popular Searches</div>
        <div class="secondbox">
          <div class="secondbox-firstrow">
            <a href="/search?q=top+box">Top Box</a>
            <a href="/search?q=goggle">Goggle</a>
            <a href="/search?q=ngage+air+filter">Ngage Air Filter</a>
            <a href="/search?q=hazard+flasher">Hazard Flasher</a>
            <a href="/search?q=bar+end+mirrors">Royal Enfield Bar End Mirrors</a>
          </div>
        </div>
      </div>

      <div class="defaultSuggestSections" data-title="Popular Brands">
        <div class="searchsuggesthead">Popular Brands</div>
        <div class="brandbox">
          <div class="brandrow">
            <a href="/collections/liu-hjg">
              <img src="https://www.sparify.co/cdn/shop/files/liu-hjg-l_png.webp?v=1718732655" alt="Liu-hjg" />
              Liu-hjg
            </a>
            <a href="/collections/ngage-powerparts">
              <img src="https://cdn.shopify.com/s/files/1/0616/7799/4041/files/ngage_logo_white_web.png?v=1724052949" alt="Ngage" />
              Ngage
            </a>
            <a href="/collections/ngk">
              <img src="https://www.sparify.co/cdn/shop/files/Untitled_design_3.jpg?v=1725362551" alt="NGK" />
              NGK
            </a>
            <a href="/collections/smk">
              <img src="https://www.sparify.co/cdn/shop/files/images_f03a8d2f-befc-4202-a9be-f808a65b76cc.png?v=1727683353" alt="SMK" />
              SMK
            </a>
            <a href="/collections/red-rooster-performance">
              <img src="https://cdn.shopify.com/s/files/1/0616/7799/4041/files/Red_Rooster.png?v=1757063797" alt="Red Rooster" />
              Red Rooster
            </a>
          </div>
        </div>
      </div>

      <div class="defaultSuggestSections" data-title="Most Searched Categories">
        <div class="searchsuggesthead">Most Searched Categories</div>
        <div class="firstbox">
          <div class="firstrow2">
            <a href="/collections/helmet">
              <img src="https://www.sparify.co/cdn/shop/files/TRBOU-3-2-1_1.webp" alt="Helmet" />
              Helmet
            </a>
            <a href="/search?q=fog+lamps">
              <img src="https://www.sparify.co/cdn/shop/files/H85ac7d6141d4467786a9e0e1ed6694b10.webp" alt="Fogg Lamps" />
              Fogg Lamps
            </a>
            <a href="/search?q=dash+cam">
              <img src="https://www.sparify.co/cdn/shop/files/5ACF3D34-55CA-428A-B489-9D2741AE5206.jpg" alt="Dash Cam" />
              Dash Cam
            </a>
            <a href="/collections/intercom-bluetooth">
              <img src="https://www.sparify.co/cdn/shop/collections/wolrd_b0bzqy6l3p_4_d_20230621165116.jpg?v=1735904568&width=165" alt="Intercom" />
              Intercom
            </a>
            <a href="/collections/crash-guard">
              <img src="https://www.sparify.co/cdn/shop/files/CG-2.jpg?v=1712044046&width=713" alt="Crash Guard" />
              Crash Guard
            </a>
          </div>
        </div>
      </div>
    `;

    function injectSuggestBox() {
      if (!suggestBox) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = `
          <div class="newSrchSuggestBox">
            <div class="defaultSuggestions clearfix">
              <!-- Content will be dynamically injected in showSuggestBox() -->
            </div>
          </div>
        `;
        suggestBox = wrapper.firstElementChild;
        searchInput.parentNode.insertBefore(suggestBox, searchInput.nextSibling);
      }
    }

    function showSuggestBox() {
      if (suggestBox) {
        const recent = renderRecentSearches();
        suggestBox.querySelector(".defaultSuggestions").innerHTML =
          recent + suggestHTML;
        suggestBox.classList.add("newSrchSuggestActive");
        suggestBox.style.display = "block";
      }
    }

    function hideSuggestBox() {
      if (suggestBox) {
        suggestBox.classList.remove("newSrchSuggestActive");
        suggestBox.style.display = "none";
      }
    }

    searchInput.addEventListener("focus", function () {
      injectSuggestBox();
      if (searchInput.value.trim() === "") showSuggestBox();
    });

    searchInput.addEventListener("input", function () {
      if (searchInput.value.trim() === "") {
        showSuggestBox();
      } else {
        hideSuggestBox();
      }
    });

    searchInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        const val = searchInput.value.trim();
        if (val) saveRecentSearch(val);
      }
    });

    document.addEventListener("click", function (e) {
      if (suggestBox && !suggestBox.contains(e.target) && e.target !== searchInput) {
        hideSuggestBox();
      }
    });

  } else if (!document.body.classList.contains("CP_SP_Search_Bar_04")) {
    window.requestAnimationFrame(window.CP_SP_Search_Bar_04);
  }
};

window.CP_SP_Search_Bar_04();
}